<script lang="ts" setup>
import { computed } from 'vue';
import CopyableText from '../CopyableText.vue';
type Props = {
  text: string;
  tooltipText: string;
  icon?: any;
  showCheck?: boolean;
  copyable?: boolean;
  loading?: boolean;
  height?: string | number;
};

const props = withDefaults(defineProps<Props>(), {
  text: '',
  tooltipText: '',
  icon: undefined,
  showCheck: false,
  copyable: false,
  loading: false,
  height: '40px',
});
const slots = defineSlots<{
  control?: any;
  controls?: any;
  content?: any;
}>();

const base64SVGIcon = computed(() => {
  if (typeof props.icon === 'string' && props.icon.startsWith('data:image/svg+xml;utf8,')) {
    const base64svg = `data:image/svg+xml,${encodeURIComponent(props.icon.replace('data:image/svg+xml;utf8,', ''))}`;
    return base64svg;
  }

  return props.icon;
});
</script>

<template>
  <v-row class="ga-2 align-center flex-nowrap" :style="{ height: height }" no-gutters>
    <v-col v-if="icon" cols="auto">
      <v-tooltip location="top" :text="tooltipText" :disabled="copyable">
        <template v-slot:activator="{ props }">
          <!-- The icon is the only thing saying which identifier this row holds, and the tooltip
          that says it out loud is not a name. Both carry it themselves instead, as pictures rather
          than the buttons Vuetify makes of anything its activator props are bound to. -->
          <template v-if="typeof icon === 'string' && icon.startsWith('data:')">
            <v-img v-bind="props" :src="base64SVGIcon" :alt="tooltipText" width="24" height="24"></v-img>
          </template>
          <template v-else>
            <v-icon class="text-primary" v-bind="props" :icon="icon" role="img" :aria-label="tooltipText"></v-icon>
          </template>
        </template>
      </v-tooltip>
    </v-col>
    <v-col v-if="loading" cols="auto">
      <v-skeleton-loader type="text" width="100" height="40"></v-skeleton-loader>
    </v-col>
    <v-col v-else cols="auto" class="text-truncate" :style="{ maxWidth: `calc(${!showCheck ? '100% - 44px' : ''})` }">
      <CopyableText v-if="!slots.content && !copyable" :text="text" />
      <span v-if="!slots.content && copyable">{{ text }}</span>
      <slot name="content" />
    </v-col>
    <v-col v-if="showCheck" cols="auto">
      <v-icon icon="mdi mdi-check-circle" color="success" size="x-small"></v-icon>
    </v-col>
    <v-spacer v-if="slots.control"></v-spacer>
    <v-col v-if="slots.control" cols="auto">
      <slot name="control" />
    </v-col>
  </v-row>
  <v-row v-if="slots.controls" class="d-flex flex-column ga-2 align-end" no-gutters>
    <v-col cols="12" class="d-flex flex-column text-right">
      <slot name="controls" />
    </v-col>
  </v-row>
</template>
